export enum STATUS_HISTORY {
	MANUAL = 'MANUAL',
	INCOMPLETE = 'INCOMPLETE',
	DENY = 'DENY',
	CARRYOVER = 'CARRYOVER',
	CARRYOVER_SPLIT = 'CARRYOVER_SPLIT'
}
